import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { NotificationSettingResource } from "@exonn/js-sdk";

export const module: ModuleOptions<NotificationSettingResource> = {
  resource: ResourceEnum.NotificationSetting,
  bigIcon: <span className={"icon-20-send_chnl"} />,
  smallIcon: <span className={"icon-15-send_chnl"} />,
  // Удаляется только неиспользованная настройка — решает форма; из списка нет.
  list: { hideDeleteAction: () => true },
  tabs: { edit: { titleProp: "name" } },
};
